function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.33333 12.6667C6.59733 12.6667 6 13.2653 6 14V15.6667H8.66666V14C8.66666 13.2653 8.06933 12.6667 7.33333 12.6667Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.3333 5.33333H3.66667C1.644 5.33333 0 6.97733 0 8.99999V23C0 25.0226 1.644 26.6666 3.66667 26.6666H28.3333C30.356 26.6666 32 25.0226 32 23V8.99999C32 6.97733 30.356 5.33333 28.3333 5.33333ZM10.6667 20.3333C10.6667 20.8853 10.2187 21.3333 9.66667 21.3333C9.11467 21.3333 8.66667 20.8853 8.66667 20.3333V17.6667H6V20.3333C6 20.8853 5.552 21.3333 5 21.3333C4.448 21.3333 4 20.8853 4 20.3333V14C4 12.1627 5.49467 10.6667 7.33333 10.6667C9.172 10.6667 10.6667 12.1627 10.6667 14V20.3333ZM17.6667 12.6667H16.3333V20.3333C16.3333 20.8853 15.8853 21.3333 15.3333 21.3333C14.7813 21.3333 14.3333 20.8853 14.3333 20.3333V12.6667H13C12.448 12.6667 12 12.2187 12 11.6667C12 11.1147 12.448 10.6667 13 10.6667H17.6667C18.2187 10.6667 18.6667 11.1147 18.6667 11.6667C18.6667 12.2187 18.2187 12.6667 17.6667 12.6667ZM28 20.3333C28 20.8853 27.552 21.3333 27 21.3333C26.448 21.3333 26 20.8853 26 20.3333V15.432L25.2013 16.8293C24.844 17.4533 23.8213 17.4533 23.464 16.8293L22.6667 15.432V20.3333C22.6667 20.8853 22.2187 21.3333 21.6667 21.3333C21.1147 21.3333 20.6667 20.8853 20.6667 20.3333V11.6667C20.6667 11.2133 20.972 10.816 21.4107 10.7C21.8453 10.5853 22.3107 10.7773 22.536 11.1707L24.3347 14.3173L26.1333 11.1707C26.3587 10.7773 26.8213 10.5853 27.2587 10.7C27.6947 10.816 28 11.2133 28 11.6667V20.3333Z",
  fill: "white"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})));
function SvgAtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtm);
export default __webpack_public_path__ + "static/media/atm.9c300de8.svg";
export { ForwardRef as ReactComponent };